import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QrCode } from "lucide-react";
import QRCode from "qrcode";
import * as Sentry from '@sentry/react';

interface QrCodeModalProps {
  url: string;
  title?: string;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({
  url,
  title = "QR Code"
}) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>("");

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        const dataUrl = await QRCode.toDataURL(url, {
          width: 256,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        setQrCodeDataUrl(dataUrl);
      } catch (error) {
        Sentry.captureException(error);
      }
    };

    if (url) {
      generateQRCode();
    }
  }, [url]);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-12 w-12 p-0 ml-2"
          title="Show QR Code"
        >
          <QrCode className="h-12 w-12" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center space-y-4">
          {qrCodeDataUrl ? (
            <img
              src={qrCodeDataUrl}
              alt="QR Code"
              className="border rounded-lg"
            />
          ) : (
            <div className="w-64 h-64 bg-gray-100 rounded-lg flex items-center justify-center">
              <p className="text-gray-500">Generating QR code...</p>
            </div>
          )}
          <p className="text-sm text-center text-muted-foreground break-all">
            {url}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QrCodeModal;